import React from "react";

import { AiOutlineCar } from "react-icons/ai";

import { VehicleType } from "../../types";
type FeaturesProps = {
  vehicle: VehicleType;
  showCoreFeatures?: boolean;
};

const Features: React.FC<FeaturesProps> = ({
  vehicle,
  showCoreFeatures = true,
}) => {
  return (
    <div className="flex flex-col gap-[10px] ">
      <p className="capitalize text-[#90a3bf] font-Jakarta text-[21px] font-semibold leading-[150%] ">
        Features
      </p>
      {showCoreFeatures && (
        <div className="flex flex-wrap gap-[12px] ">
          <div className="flex flex-col gap-2 min-w-[30%] h-14 ">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
              Model
            </p>
            <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
              {vehicle.model}
            </p>
          </div>
          <div className="flex flex-col gap-2 min-w-[30%] h-14">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
              Color
            </p>
            <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
              {vehicle.color}
            </p>
          </div>
          <div className="flex flex-col gap-2 min-w-[30%] h-14">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
              Capacity
            </p>
            <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
              {vehicle.capacity}
            </p>
          </div>
          <div className="flex flex-col gap-2 min-w-[30%] h-14">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
              Plate Number
            </p>
            <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
              {vehicle.vehiclePlateNumber}
            </p>
          </div>
          <div className="flex flex-col gap-2 min-w-[30%] h-14">
            <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
              Mileage per charge
            </p>
            <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
              {vehicle.millagePerCharge}
            </p>
          </div>
          {/* <div className="flex flex-col gap-2 min-w-[30%] h-14">
          <p className=" text-[#90a3bf] font-Jakarta text-[12px] font-normal whitespace-normal  ">
            Last Maintenance
          </p>
          <p className=" text-[#596780] font-Jakarta text-[12px] lg:text-[16px] font-semibold whitespace-nowrap ">
            {vehicle.lastMaintenance}
            11/11/2021
          </p>
        </div> */}
        </div>
      )}
      {/* <p className="capitalize text-[#90a3bf] pt-5 font-Jakarta text-[12px] font-semibold leading-4 ">
        Extra Features
      </p> */}
      <div className="flex flex-wrap w-full gap-3">
        {vehicle?.extraFeatures?.map((feature, index) => (
          <div
            className="flex  gap-[8px] px-[20px] py-[8px] border items-center border-lightGreen  rounded-lg  "
            key={index}
          >
            <AiOutlineCar
              color="#215759"
              size={25}
              className="bg-lightGreen border rounded-full p-1"
            />
            {feature}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
